'use client';

import { useRouter } from 'next/navigation';

const DevNavigationPanel = () => {
  const router = useRouter();

  const handleNavigate = (formData: FormData) => {
    const slug = formData.get('slug') as string;
    router.push(`/${slug}`);
  };

  return (
    <section>
      <h3>Navigation</h3>

      <p>Put in the url you want to redirect to below (no opening slash)</p>
      <form action={handleNavigate}>
        <label>
          Slug
          <input type="text" name="slug" />
        </label>
        <button type="submit">Go</button>
      </form>
    </section>
  );
};

export default DevNavigationPanel;
